<template>
    <div class="courseListModule white_bg">

        <div class="body clearfix" :style="'height:'+height+'px'">
            <div class="fl leftSideBar white_bg h100p hiddenScrollbar" :style="'width: 23.2%; overflow-y:auto;'">
                <categorySidebar @changeCategory ="onChangeCategory"/>
            </div>

            <div class="rightInfo centerRegion fr white_bg h100p hiddenScrollbar" :style="'width: 75.73%; overflow-y:auto;'" >

                <div class="inner" style="padding: 16px 18px 0 9px;">
                    <!--                <div class="infoBox clearfix" id="secondaryCategoryContent">-->
                    <!--                    <div class="categoryList clearfix">-->
                    <!--                        <span class="item" :class="{active:!selectedId}" data-id="" v-on:click="onSelectCategory">全部</span>-->
                    <!--                        <span class="item" :class="{active:selectedId == item.id}"-->
                    <!--                            v-for="item in list" :data-id="item.id"-->
                    <!--                            v-on:click="onSelectCategory">{{item.name}}</span>-->
                    <!--                    </div>-->
                    <!--                </div>-->

                    <!-- 课程列表Start -->
                    <div class="" id="courseListArea">
                        <!-- <ul class="courseList noMargin hiddenScrollbar" :style="'height:' + (height ? height + 'px' : '100%')"> -->
                        <ul class="courseList noMargin hiddenScrollbar">
                            <li :class="{item : info.isStarLecturer === false}" class="white_bg" v-for="(info, index) in dataList" :key="index">
                                <template v-if="info && info.isStarLecturer === false">
                                    <a class="block courseInfo" @click="toDetailByBizType(-1,info.id)" href="javascript:;">

                                        <div class="font14r bold " style="color: hsla(0, 0%, 17%, 1)">
                                            <template v-if="debug">
                                                <span v-if="dataItem && dataItem.chargeMode === 'FREE' && dataItem.authorized">已报名</span>
                                                <span v-if="dataItem && dataItem.chargeMode === 'UN_FREE' && dataItem.authorized">已支付</span>
                                            </template>
                                            {{info.title}}
                                        </div>

<!--                                        <div class="marginT8">-->
<!--                                            <img src="vodCourse/study_vip_free_label_icon.png"-->
<!--                                                 width="82" height="14" v-if="info.chargeMode === 'UN_FREE' && info.isV"/>-->
<!--                                        </div>-->

                                        <div class="borderLayout marginT8 f12r16 color999">
                                            <div class="middleRegion">
                                                <div class="centerRegion paddingT12 lineHeightOneAndAHalfTimes grey">

                                                    <div class="font-style">
                                                        <span class="mr10" style="margin-right:18px">
                                                            已更新{{info.liveRecorded}}节
                                                        </span>
                                                            <span class="inlineBlock">
                                                            观看数
                                                            {{info.applicantCount + info.applicantCountSham}}
                                                        </span>

                                                    </div>

                                                    <div class="coursePrice marginT4 lineHeightOneAndAHalfTimes priceColor f14r16 bold">
<!--                                                        <span v-if="info.chargeMode=='FREE'">-->
<!--                                                            免费-->
<!--                                                        </span>-->
<!--                                                        <template v-else>-->
<!--                                                            <span class="font10r" >￥</span>-->
<!--                                                            <span class="font16r" >{{info.price}}</span>-->
<!--                                                        </template>-->
                                                        <!-- 免费 -->
                                                        <span class="red" v-if="info.chargeMode==0">免费</span>

                                                        <!-- 收费 -->
                                                        <template v-else>

                                                            <!-- 会员课程 -->
                                                            <template v-if="info.isV">
                                                                <!-- 会员课程已购买会员 -->
                                                                <template v-if="userInstance && userInstance.isContentHasVipPrivilege('datum')">
                                                                    <span class="grey deleteLine font14r">原价￥{{info.price}}</span>
                                                                    <span class="marginL8 red">免费</span>
                                                                </template>

                                                                <!-- 会员课程未购买会员 -->
                                                                <template v-else="">
                                                                    <img src="vodCourse/study_vip_free_label_icon.png"
                                                                         width="82" height="14" v-if="info.chargeMode === 'UN_FREE' && info.isV"/>
                                                                    <span class=" marginL8 red">￥{{info.price}}</span>
                                                                </template>
                                                            </template>

                                                            <!-- 非会员课程 -->
                                                            <template v-else="">
                                                                <span class=" marginL8" v-if="info.isPay">￥0.0</span><!-- 已购买 -->
                                                                <span class=" marginL8 red" v-else>￥{{info.price}}</span><!-- 未购买 -->
                                                            </template>
                                                        </template>
                                                    </div>


                                                </div>
                                                <div class="eastRegion" style="width: 86px;">

                                                    <div class="imageArea" style="height: 54px;">
                                                        <img class="coverImg fullSpace cover" :src="info.coverImg"/>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>

                                    </a>
                                </template>
                            </li>

                        </ul>

                        <!-- <div class="alignCenter mt10" v-if="loadingStatus">
                            <img src="../../image/shixun_v2_theme/loading.gif" width="80" height="auto" align="loading..."/>
                        </div>

                        <div class="alignCenter padding10 f14r16" v-if="!loadingStatus && listInfo.length < 1">没有任何内容。</div>
                            -->
                    </div>
                    <!-- 课程列表 end -->

                    <div class="" style="margin-top: 12px; margin-bottom: 32px;"
                         v-show="status==='ready' && pagination.current < pagination.totalPage"
                         @click="loadNextPage()" >
                        <img class="block loadMoreButton" src="button/loadMoreButton.png" width="100%" height="auto"/>
                    </div>

                </div>
            </div>
        </div>

    </div>
</template>
<script>
// lib and modules
import generalCmpPart from '../part/generalCmpPart';

// config and data
import appConfig from '@/appConfig';
import adTypeEnum from '../ad/adTypeEnum';

import categorySidebar from './categorySidebar'

// utils
import appHelper    from '@/util/appHelper';
import windowHelper from '@/util/windowHelper';
import {toDetailByBizType} from '@comp/shixunApp/toDetail'
import consoleHelper from "@util/consoleHelper";
import consoleApi from "@comp/platformApi/consoleApi";
import userUtil from "@comp/shixunApp/userUtil";

const config = {
    name : 'courseListModule',
    apiConfig : {
        list : {
            url : 'portal/courseVod/listForAudience',
            params:{
                categorySecondId:'',
                categoryFirstId:''
            },
            dataPath : 'data.rows',
            totalPath : 'data.totalCount',
            totalPagePath : 'data.totalPage'
        }
    },
    demoTitleList : [
        '奥尔夫音乐课程春秋课新精选课程',
        '如何使运营的微信公众号活跃起来？',
        '做好这几点，让园区摆脱对名师的依赖'
    ]
};

export default {
    name: config.name,
    extends : generalCmpPart,
    components : { categorySidebar },
    data(){
        return {
            title : config.title,
            description : config.description,
            pageKey: 'jpcourses-list',
            apiConfig : config.apiConfig,
            enableDataList : true,
            autoLoadDataList : appConfig.mode != 'demo',

            height : 0,
            header : {
                height : 44
            },
            adTypeEnum : adTypeEnum,

            toDetailByBizType:toDetailByBizType,

            debug : consoleHelper.getDebugStatus(),

            userData : null,
            userInstance : null,
        }
    },
    methods:{

        setContainerHeight() {
            let h = windowHelper.getHeight();
            this.height = h - this.header.height;
        },

        viewItem(dataItem) {
            appHelper.goToPage('', {
                id : dataItem.id
            });
        },


        onChangeCategory(result) {
            let categoryFirstId = result.categoryFirstId || '';
            let categorySecondId = result.categorySecondId || '';

            if (categoryFirstId)
            {
                this.apiConfig.list.params.categoryFirstId = categoryFirstId;
            }
            else
            {
                delete this.apiConfig.list.params.categoryFirstId;
            }

            if (categorySecondId)
            {
                this.apiConfig.list.params.categorySecondId = categorySecondId;
            }
            else
            {
                delete this.apiConfig.list.params.categorySecondId;
            }

            this.reloadDataList();
        }
    },
    mounted(){

        consoleApi.log('[courseList] ' + config.note);

        const me = this;

        if (typeof(window) === 'object')
        {
            window.addEventListener('resize', () => {

                if (!me)
                {
                    return;
                }
                me.setContainerHeight();
            });
            me.setContainerHeight();
        }

        appHelper.checkLogin((error, result) => {

            if (error)
            {
                return;
            }
            if (result)
            {
                this.userData = result;
                this.userInstance = userUtil.createUser(result);
            }
            else {
                this.setWechatShare();
            }
        });

    }
}
</script>
<style scoped lang="scss">

.font-style{
    font-size: 10px;
    font-weight: 400;
    line-height: 14px;
}

.grey {
    color: hsla(219, 16%, 60%, 1);
}
.red {
    color: hsla(2, 100%, 61%, 1);
}

.courseList {
    list-style-type:none;
    padding-left: 0px;
}

.courseInfo{
    /*padding-left: 30px;*/
    display: block;
    color: black;
    text-decoration: none;
    padding: 10px 0;
}

.courseInfo .imageArea {
    /*float: right;*/
    /*width:78px;*/
    /*height:39px;*/
    /*margin-left: 10px;*/
    /*margin-top: 10px;*/
}

.courseInfo .imageArea img {
    /*width: 100%;*/
    /*height: 100%;*/
}

.coverImg{
    /*width: 353px;*/
    width: 100%;
    height: 100%;
    object-fit: cover;

    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    border-radius: 4px;
}
.courseTitle{
    font-weight: bold;
    font-size: 16px;
    /*margin: 8px 0;*/
    margin: 0 0 2px;
}

.courseInfo .base {
    padding-bottom: 10px;
}

#secondaryCategoryContent .categoryList {
    color: #666;
    font-size: 12px;

    padding-bottom: 6px;
    border-bottom: solid 1px rgb(238,238,238);
}
#secondaryCategoryContent .categoryList .item {
    float: left;
    margin-right: 1.5em;
    margin-bottom: .5em;
    font-weight: bolder;
    font-size: 13px;
}
#secondaryCategoryContent .categoryList .item.active {
    color: #FD8A2D
}

/*.info {*/
/*    color: gray;*/
/*}*/
.courseList .item{
    overflow: hidden;
    border-bottom: solid 1px #EEE;
}

/*.courseList .coursePrice .vipShow {*/
/*    width: 48px;*/
/*    height: 13px;*/
/*}*/

.home-V{
    background-size: 100% 100%;
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAABS2lUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxMzggNzkuMTU5ODI0LCAyMDE2LzA5LzE0LTAxOjA5OjAxICAgICAgICAiPgogPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIi8+CiA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgo8P3hwYWNrZXQgZW5kPSJyIj8+IEmuOgAAAaZJREFUOI3Nk7FLm0EYxn8XXGqIk3sWMUMF0cn2L6hE4iCkgSwFxw51MrTQu+9K/4PG3U3HDo5uQlMktA4OlqRD5y+TSKC99/vs4Jv65WtsWujgCy9373PP+9xzdxzctzAAURQB4BpRAXgGPAZmJvAF+ADs+8MozfaOk1PeAi+nbL4NLACvsmBhNHFb0RoJLRL4i2y5rWjtt6Ndf2YW+ARUprjJxhdg1awwvHUkeIQKAv+QFQQ/7qhjroAisAeUgY0/ODkCvgHPgaF5dF28dRT4QQAC8wQaBDpa57Oj6/Nafx+pj4SsLjzVeY1ALyfSU/y18m76skL+xLUR2nr2XYQ6wjpCrFisdR2hpdieP3HtcUc3rnYIvNed3hFYIlBVJxsEHiqO8l5kL+6XkO+6BDFNxHQQU0DMAWLmfNctIqaEmEPFPyKm6bsumSgE4M/sEGEToY/wAOHYLb25RDjWuo9Q82d2mH/KQh7w5zZGeIIw0Lso6ThAWPfnNs73TBQC8Bf2KwlVEmL9EjEJVX9h+5P4dwoB+J49JaVMyjIpZd+zp3dx/2v8BLKS1SS9ANXZAAAAAElFTkSuQmCC);
    width: 16px;
    height: 16px;
}
.applicantIcon{
    background-size: 100% 100%;
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABS2lUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxMzggNzkuMTU5ODI0LCAyMDE2LzA5LzE0LTAxOjA5OjAxICAgICAgICAiPgogPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIi8+CiA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgo8P3hwYWNrZXQgZW5kPSJyIj8+IEmuOgAAARFJREFUOI210j1LnFEQBeBndY0QcAvxfyipUm1sA4EggoWtxRSChUUKIUgsxMoyMIVNSLWNCNaCnZVg729YsBH8xOYu3H3dvJLCU92ZOefMzL2XCpnZ1YJJ9alGvJOZa/8Qr2HnLYN9rGdmvyHuY73Ux9AphBV8KbkZfMMJnkuT7zjFQ+GcR8QxdDJzHkf4hY+YnrRCwRNusYuNiBh20cNV6fIZdy0Gs7go/B6G9a0uRcTXFrGy7l9cj+LaoNMgrmIRexHxWJXq86tXqDGHnxi0TdRmAGfYaiO0/bwB/kTEcyM/tmptcJOZP3BfEzKzDj9MmuAeC9jE8htTPeI3DkaNRj/xEJ9ahE1cRsT2f/DfES/6s0VpT6slVwAAAABJRU5ErkJggg==);
    width: 16px;
    height: 16px;
    vertical-align: middle;
}
.vipShow{
    background-size: 100% 100%;
    background-image: url(data:image/png;base64,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);
    width: 66px;
    height: 18px;
    vertical-align: middle;
    margin-right: 2px;
    margin-top: -3px;
}
.deleteLine {
    text-decoration: line-through;
}
</style>
